const Config = {
  prismic: {
    api_url: 'https://dovedale-deisgn-studio.prismic.io/api',
    login: 'https://dovedale-deisgn-studio.prismic.io/',
    links: function (doc) {
      // Pretty URLs for known types
      if (doc.type === 'collection') return '/collections/' + doc.uid
      if (doc.type === 'page') return '/' + doc.uid
      return '/docs/' + doc.id // Fallback for other types, in case new custom types get created
    }
  },
  shopify: {
    accessToken: process.env.SHOPIFY.TOKEN, // '8a0c07bee1845146ae15bd8d602ceb84',
    domain: process.env.SHOPIFY.DOMAIN, // 'dovedaledesign.myshopify.com',
    appId: process.env.SHOPIFY.APP_ID // '6'
  },
  bkpt: {
    mobile: 600,
    image360: 720 // 720 microsoft surface
  },
  title: 'Dovedale Design Studio',
  email: 'info@dovedaledesignstudio.com',
  phone: '+44 779 382 2428',
  socialMedia: {
    Twitter: 'https://twitter.com/dovedale2016',
    Instagram: 'https://www.instagram.com/dovedaledesignstudio/',
    Facebook: 'https://www.facebook.com/dovedaledesignstudio/',
    Pinterest: 'https://www.pinterest.com/dovedaledesignstudio/'
  },
  mailchimpID: 'a60f52dceb'
}
module.exports = Config



// WEBPACK FOOTER //
// ./src/config.js